import { render, staticRenderFns } from "./BrancePersonal.vue?vue&type=template&id=d977913e"
import script from "./BrancePersonal.vue?vue&type=script&lang=js"
export * from "./BrancePersonal.vue?vue&type=script&lang=js"
import style0 from "./BrancePersonal.vue?vue&type=style&index=0&id=d977913e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports